import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-bold" }
const _hoisted_2 = { class: "q-pb-md" }

import { useDialogPluginComponent } from "quasar"
import SfxDialogHttpBase from "src/components/dialogs/http/SfxDialogHttpBase.vue"
import SfxExternal from "src/components/special/SfxExternal.vue"
import { COMMON_MESSAGES } from "src/util/constants/commonMessages"
import { IMG_MASCOT_STOP } from "src/util/constants/files"

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogHttp401',
  setup(__props) {

const { dialogRef, onDialogOK } = useDialogPluginComponent()

//endregion

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(SfxDialogHttpBase, {
        title: _ctx.$t('sfxDialogHttp.title_401'),
        "http-code": "401",
        "img-src": _unref(IMG_MASCOT_STOP),
        onClick: _unref(onDialogOK)
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("sfxDialogHttp.body_401_1")), 1),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("sfxDialogHttp.body_401_2")), 1),
          _createVNode(_component_i18n_t, {
            keypath: "sfxDialogHttp.body_401_3",
            tag: "div",
            class: "text-bold"
          }, {
            url: _withCtx(() => [
              _createVNode(SfxExternal, {
                href: _unref(COMMON_MESSAGES).SUPPORT_LINK
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogHttp.url_support")), 1)
                ]),
                _: 1
              }, 8, ["href"])
            ]),
            _: 1
          })
        ]),
        quote: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogHttp.quote_401")), 1)
        ]),
        _: 1
      }, 8, ["title", "img-src", "onClick"])
    ]),
    _: 1
  }, 512))
}
}

})